import React, { Fragment, useEffect, useRef } from 'react';
import { validateAccount } from '../../../services/account.service';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { AxiosError } from 'axios';
import { showAxiosMessageError } from '../../../services/error-message.service';

/**
 * Page par laquelle sera confirmé ou non le compte créé
 *
 * @constructor
 */
export default function AccountValidationPage() {
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);
    // Etat par défaut du contenu de la page avant récupération dans le back
    const { token } = useParams();
    const showMessage = useSnackbars();
    const navigate = useNavigate();
    // Récupère les données du back permettant de construire la page
    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;
        validateAccount(token)
            .then(result => {
                if (result.success) {
                    showMessage.successAlert(result.message);
                    navigate('/');
                } else {
                    navigate('/creation-compte-invalide');
                }
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
                navigate('/creation-compte-invalide');
            });

        //https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Fragment></Fragment>;
}
